import angular from 'angular';
import { some } from 'lodash';

export default angular
    .module('application.scene.authorized.scene.team-share', [])
    .config(stateConfiguration);

/* @ngInject */
function stateConfiguration($stateProvider, $transitionsProvider) {
    $stateProvider.state('authorized.team-share', {
        url: '/team-share/:teamId',
        params: {
            teamId: null
        }
    });

    $transitionsProvider.onStart({
        to: 'authorized.team-share'
    }, (transition) => {
        let { teamId } = transition.params() || {};

        const $state = transition.injector().get('$state');
        const sessionService = transition.injector().get('sessionService');

        return sessionService.initialize().then((data) => {
            if (some(data.teams || [], (team) => team.id === +teamId)) {
                return $state.target('authorized.calendar', {
                    teamId
                });
            }

            return $state.target('authorized');
        }).catch(() => $state.target('authorized'));
    });
}



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/team-share/index.js